import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  getLoginUrl,getResetPasswordUrl
} from "../../../utils/common";

const WithError = (props) => {
  const { t } = useTranslation();
  const { errors, errorArray } = props;
  return (
    <Container className="error">
      <Row>
        <Col lg={{ span: 6, offset: 3 }}>
          <div role="alert" aria-live="assertive" className="error__block">
            <div className="error__block-header">
              {t("common.errors.problem")}
            </div>
            <div className="error__block-body">
              {errorArray.length > 0
                ? errorArray.map((error) => {
                  let content = "";
                  if (
                    error.property === "mail" &&
                    error.policyRequirements[0].policyRequirement === "UNIQUE"
                  ) {
                    content = (
                      <div
                        className="error__block-body-section"
                        key={error.property}
                      >
                        <p>{t("common.errors.invalidEmail")}</p>
                        <ul>
                        <li>{t("common.errors.invalidEmailDesc")} </li>
                        </ul>
                        
                      </div>
                    );
                  } else if (
                    error.property === "userName" &&
                    error.policyRequirements[0].policyRequirement === "UNIQUE"
                  ) {
                    content = (
                      <div
                        className="error__block-body-section"
                        key={error.property}
                      >
                        <p>{t("common.errors.invalidUserName")}</p>
                        <ul>
                        <li>{t("common.errors.invalidUserNameDesc")} </li>
                        </ul>
                        {/* <Link to={getLoginUrl()}>{t("common.errors.clickHereLogin")}</Link> {' '+t("pages.login.or")+' '} <Link to={getResetPasswordUrl()}>{t("common.errors.resetYourPassword")}</Link> */}
                      </div>
                    );
                  }
                  return content;
                })
                : t(errors)}
                {errorArray.length > 0 && <div><Link to={getLoginUrl()}>{t("common.errors.clickHereLogin")}</Link> {' '+t("pages.login.or")+' '} <Link to={getResetPasswordUrl()}>{t("common.errors.resetYourPassword")}</Link></div>}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

WithError.propTypes = {
  errors: PropTypes.string,
  errorArray: PropTypes.array
};
WithError.defaultProps = {
  errors: "",
  errorArray: []
};
export default WithError;
